/**
 * Auth utility functions.
 * This file exists to break circular dependencies in auth-related slices.
 */

import BrightbackSession from '@bbkAdminUtils/brightback-session';

export const isSignedIn = (): boolean =>
  Boolean(BrightbackSession.getAccessToken());
